import React, { memo, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { authService } from 'src/utils/oauth/AuthService';
import { resolveSafeRedirect } from 'src/utils/oauth/safe-redirect';
import constants from 'src/constants';

const HOLD_MS = 3000;


export const Logout: React.FC = memo(() => {
  const location = useLocation();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) {
      return;
    }
    started.current = true;

    const searchParams = new URLSearchParams(location.search);
    const returnUrlFlag = searchParams.get('returnUrl');
    const returnUrlParam = searchParams.get('returnUrl');
    const redirectParam = searchParams.get('redirect');
    const postLogout = searchParams.get('post_logout_redirect_uri');
    // QLST: redirect=<url>&returnUrl=1 | DMST cũ: returnUrl=<url>
    const redirectUri =
      redirectParam ||
      (returnUrlParam && /^https?:\/\//i.test(returnUrlParam)
        ? returnUrlParam
        : null) ||
      (postLogout && /^https?:\/\//i.test(postLogout) ? postLogout : null);
    const returnToApp =
      !!redirectUri &&
      (returnUrlParam === '1' ||
        returnUrlParam === 'true' ||
        (!!returnUrlParam && /^https?:\/\//i.test(returnUrlParam)) ||
        !!postLogout);

    const run = async () => {
      const result = await authService.performSsoLogout(returnUrlFlag ? redirectUri || undefined : undefined);

      let nextUrl: string;
      if (result.providerLogoutUrl) {
        if (redirectUri && returnToApp) {
          authService.rememberPostLogoutReturn(decodeURIComponent(redirectUri));
        }
        nextUrl = result.providerLogoutUrl;
      } else if (returnUrlFlag) {
        nextUrl = result.postLogoutRedirectUrl || `${constants.BASE_URL}/login`;
      } else if (redirectUri) {
        nextUrl = returnToApp
          ? decodeURIComponent(redirectUri)
          : `${constants.BASE_URL}/login?redirect=${encodeURIComponent(redirectUri)}`;
      } else {
        const safeRedirect = resolveSafeRedirect(redirectUri, '');
        nextUrl = safeRedirect
          ? `${constants.BASE_URL}/login?redirect=${encodeURIComponent(safeRedirect)}`
          : `${constants.BASE_URL}/login`;
      }

      window.setTimeout(() => {
        window.location.href = nextUrl;
      }, HOLD_MS);
    };

    void run();
  }, [location.search]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        fontFamily: 'Segoe UI, sans-serif',
        background: '#f5f6f8',
        color: '#1f2937',
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          border: '3px solid #d1d5db',
          borderTopColor: '#2563eb',
          borderRadius: '50%',
          animation: 'sso-logout-spin 0.8s linear infinite',
        }}
      />
      <p style={{ margin: 0, fontSize: 16, fontWeight: 500 }}>
        Đang đăng xuất…
      </p>
      <style>
        {`@keyframes sso-logout-spin { to { transform: rotate(360deg); } }`}
      </style>
    </div>
  );
});
